/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Login',dictionary:{"de":{"references":{"groups":"Gruppen","worker":"Mitarbeiter"},"general":{"name":"Name","username":"Benutzername","email":"Email"},"status":{"passwordUpdatePending":"Passwort erneuern","blocked":"Blockiert"},"passwordHash":"Passwort","__getters":{"groupNamesString":"Gruppen"}},"en":{"references":{"groups":"Groups","worker":"Worker"},"general":{"name":"Name","username":"Username","email":"Mail"},"status":{"passwordUpdatePending":"Password update pending","blocked":"Blocked"},"passwordHash":"Password","__getters":{"groupNamesString":"Groups"}}}})
import { Group } from './Group';
import { Worker } from './Worker';

export class Login extends _BaseModel {
	
	static toString() {
		return 'Login'
	}
	
	get __getters() {
		const self = this;
		return {
			get groupNamesString() {
        const groupsArray = self.references.groups;
        const groupNames = groupsArray
            .map(function (item) {
                return item.general.name;
            })
            .sort();

        return groupNames.join(', ');
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Login.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Login', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Login.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Login', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Login.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Login', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Login', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Login', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Login.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Login', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Login', path:'meta.currentDocument'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Login', path:'meta.revisions'}) ],
				model: Login,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	groups:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Group'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Login', path:'references.groups'}) ],
				model: Group,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	worker:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Login', path:'references.worker'}) ],
				model: Worker,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			general: 				{
					
	name:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Login.general.name'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Login', path:'general.name'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Login', path:'general.name'}) ],
},
    
	},
	
					
	username:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Login.general.username'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Login', path:'general.username'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Login', path:'general.username'}) ],
},
    
	},
	
					
	email:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Login.general.email'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Login', path:'general.email'}) ],
},
    
	},
	
},
			status: 				{
					
	passwordUpdatePending:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Login.status.passwordUpdatePending'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Login', path:'status.passwordUpdatePending'}) ],
},
    
	},
	
					
	blocked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Login.status.blocked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Login', path:'status.blocked'}) ],
},
    
	},
	
},
				
	passwordHash:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Login.passwordHash'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Login', path:'passwordHash'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Login', path:'passwordHash'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Login._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, general={}, status={}, passwordHash='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.general=GeneralClass.create(general);
		this.status=StatusClass.create(status);
		this.passwordHash=passwordHash;
		this._id=_id;
	}

	static create(data) {
		return new Login(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Login || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Login.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Login ? item : Login.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({groups=[], worker=[], }={}){
		if(Array.isArray(groups)){
			this.groups=[];
			for(const item of groups){
				if(typeof item === 'string') this.groups.push(item)
				else if(typeof item === 'object')
					this.groups.push(item instanceof Group ? item : Group.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.groups=groups;
		}
		if(Array.isArray(worker)){
			this.worker=[];
			for(const item of worker){
				if(typeof item === 'object')
					this.worker.push(item instanceof Worker ? item : Worker.create(item))
				else this.worker.push(item)
			}
		} else {
			this.worker=worker;
		}
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class GeneralClass {
	constructor({name='', username='', email='', }={}){
		this.name=name;
		this.username=username;
		this.email=email;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}

class StatusClass {
	constructor({passwordUpdatePending=false, blocked=false, }={}){
		this.passwordUpdatePending=passwordUpdatePending;
		this.blocked=blocked;
	}

	static create(data) {
		return new StatusClass(data);
	}
}
